import geneTestResultsFilterByResult from './geneTestResultsFilterByResult';
import propertyLevelLeftMargin from './propertyLevelLeftMargin';



// WEBPACK FOOTER //
// ./src/scripts/filters/index.js